/**
 * Coachify review product rules.
 * Provider->customer reviews are enabled by default; set explicit false to disable.
 */

export const ENABLE_PROVIDER_TO_CUSTOMER_REVIEWS =
  process.env.REACT_APP_ENABLE_PROVIDER_TO_CUSTOMER_REVIEWS !== 'false';

export const CUSTOMER_REVIEW_PROMPT_BODY =
  'Your session is complete. Please leave a review for your coach.';

export const CUSTOMER_REVIEW_PROMPT_CTA_LABEL = 'Leave a Review for Coach';
